module.exports = __webpack_public_path__ + "static/media/p_PCG_Logo_Large.4f2b5b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Pcg/p_PCG_Logo_Large.png
// module id = 553
// module chunks = 0